export default __webpack_public_path__ + "static/superbetter-fc899ed045ad9776080c2ad0691b7820.webp";